import { render, staticRenderFns } from "./VsNoChartData.vue?vue&type=template&id=21f0266b&scoped=true&"
import script from "./VsNoChartData.vue?vue&type=script&lang=js&"
export * from "./VsNoChartData.vue?vue&type=script&lang=js&"
import style0 from "./VsNoChartData.vue?vue&type=style&index=0&id=21f0266b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0266b",
  null
  
)

export default component.exports